import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/parallax';

import {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Parallax,
} from 'swiper/modules';

import '../css/Carrusel.css';


// Imágenes carrusel

import imagen13 from '../img/Carrusel/c13.jpg';
import imagen14 from '../img/Carrusel/c14.jpg';
import imagen15 from '../img/Carrusel/c15.jpg';
import imagen16 from '../img/Carrusel/c16.jpg';
import imagen17 from '../img/Carrusel/c17.jpg';
import imagen18 from '../img/Carrusel/c18.jpg';
import imagen19 from '../img/Carrusel/c19.jpg';
import imagen20 from '../img/Carrusel/c20.jpg';
import imagen21 from '../img/Carrusel/c21.jpg';
import imagen23 from '../img/Carrusel/c23.jpeg';
import imagen24 from '../img/Carrusel/c24.jpeg';
import imagen26 from '../img/Carrusel/c26.jpeg';
import imagen27 from '../img/Carrusel/c27.jpeg';


// Aviso flotante

import avisoMedia from '../img/AvisoFlotante/Completada.jpg';

const AVISO_LINK = '';



const CarouselComponent = () => {


const [isFloatingMessageVisible,setIsFloatingMessageVisible]
=
useState(true);


const [progress,setProgress]=useState(0);


const swiperRef = useRef(null);



const [position,setPosition]=useState({
x:0,
y:0
});


const dragRef = useRef({
isDragging:false,
startX:0,
startY:0
});



// Barra progreso

useEffect(()=>{


const interval=setInterval(()=>{


if(swiperRef.current){


const swiper =
swiperRef.current.swiper;


const total =
swiper.slides.length;


const current =
swiper.realIndex;



setProgress(
((current + swiper.progress) / total)*100
);


}


},50);



return()=>clearInterval(interval);


},[]);




// Imágenes

const images=[

imagen23,
imagen24,
imagen26,
imagen27,
imagen21,
imagen20,
imagen19,
imagen18,
imagen17,
imagen16,
imagen15,
imagen14,
imagen13

];





// Drag aviso


const handleMouseDown=(e)=>{


dragRef.current.isDragging=true;


dragRef.current.startX =
e.clientX-position.x;


dragRef.current.startY =
e.clientY-position.y;


};



const handleMouseMove=(e)=>{


if(!dragRef.current.isDragging)
return;



setPosition({

x:e.clientX-dragRef.current.startX,

y:e.clientY-dragRef.current.startY

});


};



const handleMouseUp=()=>{


dragRef.current.isDragging=false;


};



useEffect(()=>{


window.addEventListener(
'mousemove',
handleMouseMove
);


window.addEventListener(
'mouseup',
handleMouseUp
);



return()=>{


window.removeEventListener(
'mousemove',
handleMouseMove
);


window.removeEventListener(
'mouseup',
handleMouseUp
);


};


},[]);





// Abrir aviso


const handleOpen=()=>{


const url =
AVISO_LINK.trim() !== ''
?
AVISO_LINK
:
avisoMedia;



window.open(url,'_blank');


};




// Render aviso multimedia


const renderMedia=()=>{


const ext =
avisoMedia.split('.')
.pop()
.toLowerCase();



if(
['mp4','mov','webm']
.includes(ext)
){


return (

<video

src={avisoMedia}

autoPlay

loop

muted

playsInline

onDoubleClick={handleOpen}

className="esc-aviso-media"

/>

);


}




if(ext==='pdf'){


return (

<div className="esc-pdf-aviso">


<iframe

src={avisoMedia}

title="Aviso PDF"

/>


<div

onDoubleClick={handleOpen}

className="esc-pdf-capa"

/>

</div>


);


}





return (

<img

src={avisoMedia}

alt="Aviso"

onDoubleClick={handleOpen}

className="esc-aviso-media"

/>


);


};





return (

<section className="esc-carrusel-container">



<div className="esc-carrusel-progreso">

<div

style={{
width:`${progress}%`
}}

/>

</div>




<Swiper

ref={swiperRef}

modules={[

Navigation,

Pagination,

Autoplay,

EffectFade,

Parallax

]}


effect="fade"


loop


autoplay={{

delay:3000,

disableOnInteraction:false

}}


navigation


pagination={{
clickable:true
}}


speed={1000}


parallax



className="esc-carrusel-swiper"


>



{
images.map((img,index)=>(


<SwiperSlide key={index}>


<div className="esc-carrusel-slide">


<img

src={img}

alt={`Imagen ${index+1}`}

className="esc-carrusel-imagen"

/>


</div>


</SwiperSlide>


))
}



</Swiper>





{
isFloatingMessageVisible && (


<div


className="esc-aviso-flotante"


style={{

top:`calc(50% + ${position.y}px)`,

left:`calc(50% + ${position.x}px)`

}}


onMouseDown={handleMouseDown}


>



{renderMedia()}



<button

className="esc-cerrar-aviso"
aria-label="Cerrar aviso"

onClick={()=>setIsFloatingMessageVisible(false)}

>

✕

</button>



</div>


)

}




</section>


);


};



export default CarouselComponent;